module.exports = __webpack_public_path__ + "img/s_pink_heart.6b7bff5f.png";